import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/arrow_down2.svg'
import _imports_1 from '@/assets/img/active-clock.svg'
import _imports_2 from '@/assets/img/unactive-clock.svg'


const _withScopeId = n => (_pushScopeId("data-v-e0250c36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-border tw-border-[#EFF0F1] tw-border-solid tw-rounded-[6px]" }
const _hoisted_2 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-[62px]"
}
const _hoisted_3 = { class: "tw-flex tw-flex-row tw-justify-start tw-items-center" }
const _hoisted_4 = { class: "tw-px-[25px] tw-py-[20px] tw-font-Poppins tw-text-[15px] tw-font-[600] tw-text-[#211F58]" }
const _hoisted_5 = { class: "tw-font-[400]" }
const _hoisted_6 = { class: "float-right button-arrow dropdown-button-arrow-img" }
const _hoisted_7 = {
  key: 0,
  class: "dropdown-button-arrow-img",
  src: _imports_0
}
const _hoisted_8 = {
  key: 1,
  class: "collap-button-arrow-down-img",
  src: _imports_0
}
const _hoisted_9 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-[62px]"
}
const _hoisted_10 = { class: "tw-flex tw-gap-[10px] tw-items-center tw-flex-wrap" }
const _hoisted_11 = {
  key: 0,
  class: "dropdown-button-arrow-img",
  src: _imports_1
}
const _hoisted_12 = {
  key: 1,
  class: "dropdown-button-arrow-img",
  src: _imports_2
}
const _hoisted_13 = ["value", "onKeyup", "onBlur"]
const _hoisted_14 = {
  key: 1,
  class: "tw-text-[13px] tw-text-[500] tw-text-[#211F58]"
}
const _hoisted_15 = {
  key: 2,
  class: "tw-text-[13px] tw-text-[500] tw-text-[#878787]"
}
const _hoisted_16 = { class: "tw-flex tw-gap-[15px] tw-items-center" }
const _hoisted_17 = { class: "tw-text-[#878787] tw-text-[13px] tw-font-[400]" }
const _hoisted_18 = ["id"]
const _hoisted_19 = { class: "tw-max-w-[350px] tw-px-[5px] tw-py-[3px] tw-bg-[#E4F1FF] tw-text-[#211F58] tw-rounded-[4px] tw-text-[11px] tw-font-medium tw-font-[Poppins]" }

import { Ref, computed, onMounted, ref } from "vue";
import {
  MODAL_NAME,
  checklistStatusId,
  checklistStatusNotes,
  successStatusCodes,
  CHECKLISTSTATUS,
} from "@/utils/constants";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import { IAssessmentDetail } from "@/interfaces/assessments/IAssessmentDetails";
import {
  generateGradeColorScoreWithCompletedScore,
  generateGradeScoreWithCompletedScore,
  putChecklistStatus,
  getCheckListDuplicate,
  getChecklistCSV,
  deleteChecklist,
  getCheckListStatusDetails,
  getChecklist,
} from "@/services/assessment";

import { Checklist } from "@/services/apiRoutes/routes";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { downloadCSV, getComponentUiText } from "@/utils/utilities";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import store from "@/store";
import router from "@/router";
import popoverAssessment from "./popoverAssessment.vue";
import CreateAndUpdateAssessmentModal from "./createAndUpdateAssessmentModal.vue";
import { IModalMessage } from "@/interfaces/common/common";
import dayjs from "dayjs";
import CustomDropDownItem from "../common/customDropDownItem.vue";

interface Option {
  id: number;
  arrowRed: boolean;
  statusTag: string;
  statusTagId: string;
  text: (item: any) => string;
  isShow: (item: any) => boolean;
  action: (item: any, index: number) => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentHistory',
  props: {
  title: {
    type: String,
    default: getComponentUiText(
      "app-component-assessment-existing-assessment-dropdown-subtitle-assessment-history-1",
    ),
  },
  assessments: { type: Array as () => IAssessmentDetail[], default: () => [] },
  assessmentName: { type: String, default: "" },
  checklistId: { type: Number, default: 0 },
  index: { type: Number, default: 0 },
},
  emits: ["onRefresh"],
  setup(__props, { emit }) {

const props = __props;



const createAndUpdateAssessmentShow = ref(false);
const statusAssessment = {};

statusAssessment[checklistStatusId.inProgress] = { className: "inProgress" };
statusAssessment[checklistStatusId.other] = { className: "notStarted" };
statusAssessment[checklistStatusId.created] = { className: "notStarted" };
statusAssessment[checklistStatusId.completed] = { className: "complete" };
statusAssessment[checklistStatusId.waitingOnUs] = { className: "audited" };
statusAssessment[checklistStatusId.defunct] = { className: "defunct" };
statusAssessment[checklistStatusId.paused] = { className: "onHold" };

const showIcon: Ref<boolean> = ref(true);
const totalHistory = computed(() => props.assessments.length);
const isDataLoading: Ref<boolean> = ref(true);
const isCallApiUpdate = ref(false);
const updateAssessmentNameId: Ref<number> = ref(0);

const subMenuOptions: Ref<Option[]> = ref([
  {
    id: 1,
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    text: (item) =>
      item.checklistStatusId !== checklistStatusId.completed &&
      item.checklistStatusId !== checklistStatusId.paused &&
      item.checklistStatusId !== checklistStatusId.defunct
        ? "app-component-assessment-detail-button-continue-assessment-1"
        : "app-component-assessment-detail-dropdown-option-view-assessment-title-1",
    isShow: () => true,
    action: (item) => handleContinueAssessment(item.checklistId),
  },
  {
    id: 2,
    arrowRed: false,
    statusTag: CHECKLISTSTATUS.ONHOLD,
    statusTagId: CHECKLISTSTATUS.PAUS,
    text: () => "app-component-dropdown-set-assessment-to-1",
    isShow: (item) =>
      item.checklistStatusId !== checklistStatusId.completed &&
      item.checklistStatusId !== checklistStatusId.paused &&
      item.checklistStatusId !== checklistStatusId.defunct,
    action: (item) => handlePutOnHold(item.checklistId),
  },
  {
    id: 3,
    arrowRed: false,
    statusTag: CHECKLISTSTATUS.INPROG,
    statusTagId: CHECKLISTSTATUS.INPROG,
    text: () => "app-component-dropdown-set-assessment-to-1",
    isShow: (item) => item.checklistStatusId === checklistStatusId.paused,
    action: (item) => handleTakeOffHold(item.checklistId),
  },
  {
    id: 4,
    arrowRed: false,
    statusTag: CHECKLISTSTATUS.DONE,
    statusTagId: CHECKLISTSTATUS.DONE,
    text: () => "app-component-dropdown-set-assessment-to-1",
    isShow: (item) =>
      item.checklistStatusId !== checklistStatusId.completed &&
      item.checklistStatusId !== checklistStatusId.defunct,
    action: (item) => handleSetToComplete(item.checklistId),
  },
  {
    id: 5,
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    text: () =>
      "app-component-assessment-detail-dropdown-option-download-assessment-csv-title-1",
    isShow: () => true,
    action: (item) => handleDownloadAssessmentCSV(item),
  },
  // {
  //   id: 6,
  //   arrowRed: false,
  //   statusTag: "",
  //   statusTagId: "",
  //   text: () => "app-assess-assessment-history-rename-assessment-1",
  //   isShow: (item) =>
  //     item.checklistStatusId !== checklistStatusId.completed &&
  //     item.checklistStatusId !== checklistStatusId.defunct,
  //   action: (item) => handleRenameAssessment(item.checklistId),
  // },
  // {
  //   id: 7,
  //   arrowRed: false,
  //   statusTag: "",
  //   statusTagId: "",
  //   text: () => "app-assess-assessment-history-update-description-1",
  //   isShow: (item) =>
  //     item.checklistStatusId !== checklistStatusId.completed &&
  //     item.checklistStatusId !== checklistStatusId.defunct,
  //   action: (item, index) => handleUpdateDecription(item, index),
  // },
  {
    id: 14,
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    text: () =>
      "app-component-assessment-update-assessment-detail-modal-title-1",
    isShow: (item) =>
      item.checklistStatusId !== checklistStatusId.completed &&
      item.checklistStatusId !== checklistStatusId.defunct,
    action: (item, index) => handleUpdateAssessmentDetails(item, index),
  },
  {
    id: 8,
    arrowRed: false,
    statusTag: CHECKLISTSTATUS.INPROG,
    statusTagId: CHECKLISTSTATUS.INPROG,
    text: () => "app-component-dropdown-set-assessment-to-1",
    isShow: (item) =>
      item.checklistStatusId === checklistStatusId.completed ||
      item.checklistStatusId === checklistStatusId.defunct,
    action: (item) =>
      handleUpdateToInprogress(item.checklistId, item.checklistStatusId),
  },
  {
    id: 9,
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    text: () => "app-component-assessment-title-duplicate-1",
    isShow: (item) =>
      item.checklistStatusId !== checklistStatusId.completed &&
      item.checklistStatusId !== checklistStatusId.defunct,
    action: (item) => handleDuplicate(item),
  },
  {
    id: 10,
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    text: () =>
      "app-assess-assessment-history-create-or-update-assessment-template-1",
    isShow: () => true,
    action: () => handleCreateAndUpdateAssessment(),
  },
  {
    id: 11,
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    text: () => "app-component-assessment-title-duplicate-1",
    isShow: (item) =>
      item.checklistStatusId === checklistStatusId.completed ||
      item.checklistStatusId === checklistStatusId.defunct,
    action: (item) => handleDuplicate(item),
  },
  {
    id: 12,
    arrowRed: true,
    statusTag: "",
    statusTagId: "",
    text: () => "app-assess-assessment-history-delete-assessment-1",
    isShow: (item) =>
      item.checklistStatusId !== checklistStatusId.defunct &&
      item.checklistStatusId !== checklistStatusId.completed,
    action: (item, index) => handleDeleteAssessment(index, item.checklistId),
  },
  {
    id: 13,
    arrowRed: true,
    statusTag: "",
    statusTagId: "",
    text: () => "app-assess-assessment-history-permanently-delete-assessment-1",
    isShow: (item) => item.checklistStatusId === checklistStatusId.defunct,
    action: (item, index) =>
      handleDeleteAssessmentPermanently(index, item.checklistId),
  },
]);

const checklistAssessmentHistory = computed(() => {
  const data = store.state.Assessment.checklistAssessment;
  const checklist = data.find((e) => e.checklistId === props.checklistId)
    ?.checklistItem;
  return checklist;
});
const handleCreateAndUpdateAssessment = () => {
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  createAndUpdateAssessmentShow.value = true;
};
const isChecklistAssessmentHistoryLoading: Ref<boolean> = computed(() => {
  return Object.keys(checklistAssessmentHistory).length === 0;
});

const handleDuplicate = async (data) => {
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_DUPLICATE_ASSESSMENT,
    properties: {
      checklistAssessmentData: {
        ...data,
        checklistName: `${data?.checklistName} ${getComponentUiText(
          "app-component-assessment-duplicate-assessment-modal-field-suffix-name-1",
        )}`,
        checklistDescription: data.checklistDescription,
      },
      updateDataFucntion: async (payload) => {
        await executeDuplicating(data.checklistId, payload);
      },
    },
    events: {
      "update:data": (payload) => executeDuplicating(data.checklistId, payload),
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const executeDuplicating = async (checklistId, payload) => {
  const res = await getCheckListDuplicate(checklistId, payload);
  if (
    res.data?.data &&
    res.status === successStatusCodes.OK &&
    typeof res.data.data === "object" &&
    "checklistId" in res.data.data
  ) {
    emit("onRefresh");
    showSuccessToast(
      getComponentUiText(
        "app-component-assessment-duplicate-assessment-success-1",
      ),
      getComponentUiText(
        "app-component-assessment-duplicate-assessment-link-1",
      ),
      `/assess/input?checklistId=${res.data.data.checklistId}`,
      8000,
    );
  } else {
    showError(res.data.message);
  }
};

onMounted(() => {
  isDataLoading.value = false;
});

const getScoreByChecklistId = (checklistId) => {
  const score = store.getters["Assessment/getScoreDetail"](checklistId);
  return (score?.checklistScorePcnt * 100).toFixed(1);
};
const handleRenameAssessment = (checklistId) => {
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  updateAssessmentNameId.value = checklistId;

  setTimeout(() => {
    document.getElementById("input-rename")?.focus();
  }, 300);
};

const onRenameAssessment = (e: any, checklistId: string) => {
  updateAssessmentNameId.value = 0;
  if (!e.target.value) return;
  if (isCallApiUpdate.value) return;
  isCallApiUpdate.value = true;

  store.dispatch("Assessment/updateChecklistRename", {
    checklistId: checklistId,
    params: {
      checklistName: e.target.value,
    },
  });

  setTimeout(() => {
    isCallApiUpdate.value = false;
  }, 100);
};

const handleUpdateAssessmentDetails = async (data, index) => {
  const res = await getChecklist(data.checklistId);
  const checklistAssessmentById = res.data?.data;

  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_UPDATE_ASSESSMENT_DETAIL,
    properties: {
      checklistAssessmentData: {
        ...checklistAssessmentById,
        checklistDescription: checklistAssessmentById?.checklistDescription,
        checklistName: checklistAssessmentById?.checklistName,
      },
    },
    events: {
      "update:data": () => {},
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const handleDeleteAssessment = async (index, checklistId) => {
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  await handlePostChecklistStatus(checklistId, {
    checklistStatusId: checklistStatusId.defunct,
    checklistStatusNotes: checklistStatusNotes.updateScreen,
  });
};

const handleDeleteAssessmentPermanently = async (index, checklistId) => {
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  try {
    const res = await deleteChecklist(checklistId);
    if (res.status === successStatusCodes.OK) {
      emit("onRefresh");
    } else {
      showError(res.data.message);
    }
  } catch (error: any) {
    showError(error.message);
  }
};

const handleContinueAssessment = (checklistId) => {
  const query = { checklistId: checklistId };
  router.push({ path: "/assess/input", query });
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
};

const collapseCategory = () => (showIcon.value = !showIcon.value);

const handlePostChecklistStatus = async (checklistId: number, data: any) => {
  try {
    const res = await putChecklistStatus(checklistId, data);
    if (res.data?.data && res.status === successStatusCodes.OK) {
      Promise.all([
        getChecklist(checklistId),
        getCheckListStatusDetails(checklistId),
      ]).then(([res1, res2]) => {
        //  update data in store
        store.dispatch("Assessment/updateChecklistStatus", {
          checklistId,
          params: { ...res1.data.data, ...res2.data.data },
        });
        store.dispatch("Assessment/updateStatusAssessmentHistory", {
          checklistId: checklistId,
          status: data.checklistStatusId,
          data: res2.data.data,
        });
      });
    } else {
      showError(res.data.message);
    }
  } catch (error: any) {
    showError(error.message);
  }
};

const showError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const handleSetToComplete = async (checklistId: any) => {
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_COMPLETE_ASSESSMENT,
    properties: {
      checklistParentId: props.checklistId,
      updateDataFunction: async (payload) =>
        await completeAssessment(checklistId, payload),
    },
    events: {
      "update:data": (payload) => completeAssessment(checklistId, payload),
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const completeAssessment = async (checklistId: any, value) => {
  const { note, checklistReportingDate } = value;

  const payload: Record<string, any> = {
    checklistStatusId: checklistStatusId.completed,
    checklistStatusNotes: note,
  };

  if (checklistReportingDate) {
    payload.setReportingDate = true;
    payload.checklistReportingDate = checklistReportingDate;
  }

  await handlePostChecklistStatus(checklistId, payload);
};

const handleDownloadAssessmentCSV = async (data: {
  checklistId: number;
  checklistName: string;
}) => {
  try {
    EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
    const res = await getChecklistCSV(data.checklistId);
    downloadCSV(
      res,
      `CyberSystem_Assessment_Export_${dayjs().format("YYYYMMDD_HHmmss")}_${
        data.checklistName ?? ""
      }.csv`,
    );
    showSuccessToast(
      getComponentUiText("app-api-scanning-export-csv-success-1"),
    );
  } catch (error) {
    showErrorAPI(error, Checklist.getChecklistCSV);
  }
};

const handlePutOnHold = async (checklistId: any) => {
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  await handlePostChecklistStatus(checklistId, {
    checklistStatusId: checklistStatusId.paused,
    checklistStatusNotes: checklistStatusNotes.createScreen,
  });
};

const handleTakeOffHold = async (checklistId: any) => {
  await handlePostChecklistStatus(checklistId, {
    checklistStatusId: checklistStatusId.inProgress,
    checklistStatusNotes: checklistStatusNotes.updateFromPaused,
  });
};

const handleUpdateToInprogress = async (
  checklistId: any,
  checklistStatusItemId = "",
) => {
  await handlePostChecklistStatus(checklistId, {
    checklistStatusId: checklistStatusId.inProgress,
    checklistStatusNotes:
      checklistStatusItemId === checklistStatusId.completed
        ? checklistStatusNotes.updateFromCompleted
        : checklistStatusNotes.updateFromDefunct,
  });
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
};

return (_ctx: any,_cache: any) => {
  const _component_b_popover = _resolveComponent("b-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isDataLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(`tw-cursor-pointer tw-select-none tw-pr-[25px] tw-bg-[#FCFCFD] tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-self-stretch tw-border-0  tw-border-solid tw-border-[#EFF0F1]
        ${
          showIcon.value ? 'tw-rounded-[6px]' : 'tw-rounded-t-[6px] tw-border-b-[1px]'
        }`),
          onClick: collapseCategory
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createTextVNode(_toDisplayString(__props.title) + " ", 1),
              _createElementVNode("span", _hoisted_5, "(" + _toDisplayString(totalHistory.value) + ")", 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_6, [
              (showIcon.value)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : (_openBlock(), _createElementBlock("img", _hoisted_8))
            ])
          ])
        ], 2)),
    _withDirectives(_createElementVNode("div", null, [
      (isChecklistAssessmentHistoryLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checklistAssessmentHistory.value as any, (item, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: idx,
          class: "tw-flex tw-justify-between tw-items-center tw-px-[25px] tw-py-[20px] tw-self-stretch tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-[#EFF0F1] tw-flex-wrap"
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              (__props.index === 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                : (_openBlock(), _createElementBlock("img", _hoisted_12))
            ]),
            _createElementVNode("div", null, [
              (updateAssessmentNameId.value === item.checklistId)
                ? (_openBlock(), _createElementBlock("input", {
                    key: 0,
                    id: "input-rename",
                    value: idx === 0 ? __props.assessmentName : item.checklistName,
                    type: "text",
                    class: "tw-rounded-md tw-w-[150px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-py-[5px] tw-px-[10px] tw-text-[15px] tw-font-[400] tw-text-[#211F58] tw-mr-2",
                    onKeyup: _withKeys((e) => onRenameAssessment(e, item.checklistId), ["enter"]),
                    onBlur: (e) => onRenameAssessment(e, item.checklistId)
                  }, null, 40, _hoisted_13))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(idx === 0 ? __props.assessmentName : item.checklistName), 1)),
              (
                item.checklistDateReporting
                  ? item.checklistDateReporting
                  : item.checklistStatusDate
              )
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, " - " + _toDisplayString(_unref(convertUTCTimeToLocalTime)(
                  item.checklistDateReporting
                    ? item.checklistDateReporting
                    : item.checklistStatusDate,
                )), 1))
                : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("div", { class: "tw-border tw-border-solid tw-border-[#EFF0F1] tw-px-[5px] tw-py-[3px] cell-status tw-flex tw-items-center tw-text-[11px] tw-font-[500] tw-rounded-[4px]" }, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessment-history-label-state-1",
              )), 513), [
              [_vShow, idx === 0]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createTextVNode(_toDisplayString(getScoreByChecklistId(item.checklistId)) + "% ", 1),
              _createElementVNode("span", {
                class: _normalizeClass([`${_unref(generateGradeColorScoreWithCompletedScore)(
                Number(getScoreByChecklistId(item.checklistId)),
              )}`, "tw-font-[600] tw-ml-[7px]"])
              }, _toDisplayString(_unref(generateGradeScoreWithCompletedScore)(
                  Number(getScoreByChecklistId(item.checklistId)),
                )), 3)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass([statusAssessment[item.checklistStatusId]?.className, "tw-px-[5px] tw-py-[3px] cell-status tw-flex tw-items-center tw-text-[11px] tw-font-[500] tw-rounded-[4px]"])
            }, [
              _createElementVNode("span", {
                id: `checklist-status-notes-${item.checklistId}`
              }, _toDisplayString(item.checklistStatus), 9, _hoisted_18),
              _createVNode(_component_b_popover, {
                target: `checklist-status-notes-${item.checklistId}`,
                triggers: "hover",
                placement: "top-start",
                "custom-class": "custom-actions-popover",
                offset: 8,
                delay: {
                show: 0,
                hide: 100,
              },
                onShow: ($event: any) => (true)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(convertUTCTimeToLocalTime)(item.checklistStatusDate)) + " " + _toDisplayString(item.checklistStatusNotes
                    ? `: ${item.checklistStatusNotes}`
                    : ""), 1)
                ]),
                _: 2
              }, 1032, ["target"])
            ], 2),
            _createVNode(popoverAssessment, {
              "style-button": "!tw-py-[8px] !tw-px-[8px] tw-ml-[-8px] tw-mr-[-8px] tw-items-center tw-justify-center",
              offset: 20,
              "id-popover": 
              'popover-assessment-history-' + item.checklistId + props.index
            ,
              "b-popover": "popover-has-tag"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subMenuOptions.value, (option) => {
                  return (_openBlock(), _createBlock(CustomDropDownItem, {
                    key: `option_history_${option.id}`,
                    "is-show-option": option.isShow(item),
                    "id-text": `${option.text(item)}`,
                    "custom-text-class": `tw-flex tw-items-center tw-gap-[5px] tw-w-[90%] !tw-text-[13px] !tw-font-normal !tw-leading-[19.5px] ${
                option.arrowRed ? 'tw-text-[#F7553C]' : ''
              } tw-whitespace-normal`,
                    "arrow-icon-style": `${
                option.arrowRed ? 'tw-text-[#F7553C]' : 'tw-text-[#387DFF]'
              } tw-min-w-[7px]`,
                    padding: 'tw-px-[13px] tw-py-[12px]',
                    "custom-class": 'tw-flex tw-justify-between tw-items-center !tw-border-0',
                    "tag-status": option.statusTag,
                    "tag-status-id": option.statusTagId,
                    onClick: ($event: any) => (option.action(item, __props.index))
                  }, null, 8, ["is-show-option", "id-text", "custom-text-class", "arrow-icon-style", "tag-status", "tag-status-id", "onClick"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["id-popover"])
          ])
        ]))
      }), 128))
    ], 512), [
      [_vShow, !showIcon.value]
    ]),
    _createVNode(CreateAndUpdateAssessmentModal, {
      show: createAndUpdateAssessmentShow.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((createAndUpdateAssessmentShow).value = $event)),
      "checklist-id": __props.checklistId
    }, null, 8, ["show", "checklist-id"])
  ]))
}
}

})